import { useLocation } from "react-router-dom";
import ContactSection from "../components/ContactForm";
import Footer from "../components/Footer";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import HeroSection2 from "../components/HeroSection2";
import ServicesSection from "../components/Services";
import { useEffect } from "react";

export default function ContactUs () {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

   return(
    <div className="font-body">
    <Header />
      
      <ContactSection />
      <Footer />
  </div>
   )
  
}